import React from 'react'
import PropTypes from 'prop-types'

const LinkedinPost = ({ item }) => {
  const wistiaUrlObj = item.link_url.split("feed/")
  const src = `https://www.linkedin.com/embed/feed/${wistiaUrlObj[1]}`

  return <iframe src={src} title="Viewer: Linkedin item" allowFullScreen />
}

LinkedinPost.propTypes = {
  item: PropTypes.object.isRequired
}

export default LinkedinPost